import React from "react";
import TableActions from "../../../marks/components/molecules/TableActions";
import MarksTable from "./MarksTable";

const MarksPage = ({ requests }) => {
  return (
    <div className="w-full h-screen p-6 bg-gray-50">
      <h2 className="mb-6 text-2xl font-MTNfont">Marks</h2>

      <div className="space-y-6">
        <TableActions />
        <MarksTable requests={requests} />
      </div>
    </div>
  );
};

export default MarksPage;
